import * as React from "react";
import "./style.scss";
import ContainerBox from "myshubhlife-component/container-box";
import {ApplicationStatus} from "profile/enums";
import {CC_EMAIL_ID, MessageType} from "utils/variables";
import Flashcard from "myshubhlife-component/Flashcard";
import {partnerOfferings} from "login/config";

const messageType = {
    [ApplicationStatus.INITIATED]: {
        heading: "Your application is successfully updated",
        desc: "Please allow us some time to process it.",
    },
    [ApplicationStatus.INCOMPLETE_INFO]: {
        heading: "Looks like some items are still missing",
        desc: `Please reach out to us at ${CC_EMAIL_ID} to help us complete your application`,
    },
};

interface IProps {
    message: {type: string, status: string};
    utmSource?: string;
}

const ErrorCard = (props: IProps) => {
    return (
        <ContainerBox>
            <Flashcard
                description={messageType[props.message.status].desc}
                messageType={props.message.type as MessageType}
                heading={messageType[props.message.status].heading}
                supportEmail={false}
                supportEmailText={partnerOfferings[props.utmSource]?.supportEmail}/>
        </ContainerBox>
    );
};

export default ErrorCard;
